import { MenuListLinkModel } from "./model/menu-list-link-model";
import { Component, output, input, OnInit } from "@angular/core";

import { MenuModel } from "./model/menu-model";
import { NgClass } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";
import { RouterLink } from "@angular/router";
import { DropdownLinkComponent } from "./dropdown-link/dropdown-link.component";
import { BsDropdownDirective, BsDropdownMenuDirective } from "ngx-bootstrap/dropdown";

@Component({
  selector: "portal-menu-list",
  templateUrl: "./menu-list.component.html",
  styleUrls: ["./menu-list.component.scss"],
  standalone: true,
  imports: [NgClass, TranslatePipe, RouterLink, DropdownLinkComponent, BsDropdownDirective, BsDropdownMenuDirective],
})
export class MenuListComponent implements OnInit {
  readonly Left: string = "left";
  readonly Right: string = "right";
  readonly menuChange = output<MenuModel>();
  readonly submenuChange = output<MenuListLinkModel>();
  readonly menuList = input.required<MenuModel[]>();
  readonly textAlignment = input<"left" | "right">("left");
  readonly isSticky = input(false);
  readonly backgroundColor = input("");
  isTextAlignedLeft: boolean | undefined;

  ngOnInit() {
    this.setTextAligment();
  }

  onSelectSubmenu(subMenu: MenuListLinkModel) {
    this.submenuChange.emit(subMenu);
  }

  onSelectMenu(menu: MenuModel) {
    this.menuChange.emit(menu);
    menu.isActive = true;

    // remove active class from other menus
    this.menuList().forEach((m) => {
      if (m.menuName !== menu.menuName) {
        m.isActive = false;
      }
    });
  }

  getTextAlignmentForDropdown(): string {
    return this.isTextAlignedLeft ? "" : "ml-auto";
  }

  getTextAlignmentForSubmenu(): string {
    return this.isTextAlignedLeft ? "" : "text-right";
  }

  private setTextAligment(): void {
    switch (this.textAlignment()) {
      case this.Left:
        this.isTextAlignedLeft = true;
        break;
      case this.Right:
        this.isTextAlignedLeft = false;
        break;
      default:
        this.isTextAlignedLeft = true;
        break;
    }
  }
}
